import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetDocumentsByIds = {
  documentIds: string[];
};

export const getDocumentsByIds =
  ({ documentIds }: GetDocumentsByIds) =>
  async (dispatch: Dispatch) => {
    try {
      const body = {
        ids: documentIds,
      };
      const { data } = await axiosV1.post('/documents/by-ids', body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
